import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import { ConditionalType, DataField } from '..';
import { generateUniqueId } from '../../../utils/dateFormat';
import { FormConditional } from './FormConditional';
import { FormLabelCustom } from '../styles';

export type handleOptions = {
  conditionalIndex: number
  conditionalOptionIndex: number
  fieldName?: string
  value?: string
}

interface ConditionalProps {
  formData: DataField
  setFormData: (value: React.SetStateAction<DataField>) => void
  isEmptyField: (fieldName: string) => boolean
  removesFieldFromTheEmptyFields: ({ fieldName, removeField }: {
    fieldName: string;
    removeField?: boolean;
  }) => void
}

export function Conditional({
  formData,
  setFormData,
  isEmptyField,
  removesFieldFromTheEmptyFields
}: ConditionalProps) {
  const [expanded, setExpanded] = useState<string | false>();

  const handleChangeAccordion = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
    event.stopPropagation();
  };

  // ---->  Função para atualizar os campos nome e texto de ajuda da condicional
  // const handleUpdatFieldInConditional =  (fieldName: string, value: string, index: number) => {
  //   setFormData(state => { 
  //    let condicional = [...state.condicional_campos]
  //    condicional[index] = { ...condicional[index], [fieldName]: value }

  //    return {...state, condicional_campos: condicional}})
  //  };

  const handleUpdateConditionalSelect = (value: string, index: number) => {

    setFormData(state => {
      let condicional = [...state.condicional_campos]
      condicional[index] = { ...condicional[index], tipo: value }

      return { ...state, condicional_campos: condicional }
    })
  }

  const handleRemoveConditional = (CondicionalId: string) => {
    const newConditionalAlternatives = formData.condicional_campos.filter((item) => item.id !== CondicionalId)
    setFormData(state => ({ ...state, condicional_campos: newConditionalAlternatives }))
  }

  const handleAddConditional = () => {

    const newConditional: ConditionalType = {
      id: generateUniqueId(),
      pergunta: '',
      tipo: 'Select',
      texto_ajuda: '',
      opcoes: [{
        id: generateUniqueId(),
        resposta: '',
        duplicar_campos: 0,
        texto_ajuda: '',
        lista_campos: [
          {
            id: generateUniqueId(),
            nome: '',
            tipo: 'Texto',
            resposta: '',
            texto_ajuda: '',
            opcoes: []
          }
        ]
      }]
    };

    setFormData(state => ({
      ...state, condicional_campos:
        [...state.condicional_campos, newConditional]
    }))
  }

  const handleAddNewOptionInConditional = ({ conditionalIndex }: Omit<handleOptions, 'conditionalOptionIndex'>) => {
    let newDataFields = { ...formData };
    const conditional = newDataFields.condicional_campos[conditionalIndex];

    const option = {
      id: generateUniqueId(),
      resposta: '',
      duplicar_campos: 0,
      texto_ajuda: '',
      lista_campos: [
        {
          id: generateUniqueId(),
          nome: '',
          tipo: 'Texto',
          resposta: '',
          texto_ajuda: '',
          opcoes: []
        }
      ]
    }

    let newOptions = [...conditional.opcoes, option];

    newDataFields.condicional_campos[conditionalIndex] = {
      ...conditional,
      opcoes: newOptions,
    };

    setFormData(newDataFields);
  }

  const handleRemoveOptionInConditional = ({ conditionalIndex, conditionalOptionIndex }: handleOptions) => {
    let newFormData = { ...formData }
    const condicional = newFormData.condicional_campos[conditionalIndex]
    const condiotionalOptions = condicional.opcoes;
    const removedItemFromOptions = condiotionalOptions.filter((_, i) => i !== conditionalOptionIndex)

    newFormData.condicional_campos[conditionalIndex].opcoes = [
      ...removedItemFromOptions
    ];

    setFormData(newFormData);
  }

  const handleUpdateOptionInConditional = ({
    conditionalIndex,
    conditionalOptionIndex,
    fieldName,
    value
  }: handleOptions) => {
    setFormData((state) => {
      let conditional = [...state.condicional_campos];
      const newOptionsList = [...conditional[conditionalIndex].opcoes].map((item, i) => {
        return i === conditionalOptionIndex ? { ...item, [fieldName]: value, } : item;
      })

      conditional[conditionalIndex] = {
        ...conditional[conditionalIndex],
        opcoes: newOptionsList
      }

      return { ...state, condicional_campos: conditional };
    });
  }

  return (
    <div className='row align-items-center'>
      {formData.condicional_campos.map((conditional, conditionalIndex) => (
        <div key={conditional.id} className='row col-md-12'>
          <div className="border border-secondary-subtle p-4 mb-3 col-md-12">
            <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
              <h2 className="fw-bold fs-5">Condicionais</h2>
            </div>
            <div className='row mt-3 mb-4'>
              {/* <Form.Group className="mb-3 col-md-4"> // ----> Nome da Condicional
                        <FormLabelCustom required>Nome</FormLabelCustom>
                        <Form.Control
                          placeholder="Digite o nome da pergunta para o condicional"
                          value={conditional.pergunta}
                          isInvalid={isEmptyField(`conditional.${conditional.id}`)}
                          required
                          onChange={(event) => {
                            handleUpdatFieldInConditional(
                              'pergunta',
                              event.target.value,
                              conditionalIndex,
                            );
                            removesFieldFromTheEmptyFields({
                              fieldName: `conditional.${conditional.id}`, 
                              removeField: !!event.target.value
                            })
                          }}
                        />
                        {isEmptyField(`conditional.${conditional.id}`) && 
                          <Form.Control.Feedback type="invalid">
                            Campo obrigatório
                          </Form.Control.Feedback>
                        }
                    </Form.Group> */}

              <Form.Group className="col-md-3">
                <FormLabelCustom required>Escolha o tipo de Campo</FormLabelCustom>
                <Form.Select
                  placeholder='Selecione'
                  value={conditional.tipo}
                  isInvalid={!conditional.tipo}
                  required
                  onChange={(event) => {
                    handleUpdateConditionalSelect(
                      event.target.value,
                      conditionalIndex,
                    )
                  }}
                >
                  <option value="Select">Select</option>
                  <option value="Radio button">Radio button</option>
                </Form.Select>
              </Form.Group>

              {/* <Form.Group className="mb-3 col-md-4"> // ----> Texto de ajuda da condicional
                        <FormLabelCustom required>Texto de ajuda</FormLabelCustom>
                        <Form.Control
                          placeholder="Digite o texto de ajuda para condicional"
                          value={conditional.texto_ajuda}
                          isInvalid={isEmptyField(`conditional.helper_text.${conditional.id}`)}
                          required
                          onChange={(event) => {
                            handleUpdatFieldInConditional(
                              'texto_ajuda',
                              event.target.value,
                              conditionalIndex,
                            );
                            removesFieldFromTheEmptyFields({
                              fieldName: `conditional.helper_text.${conditional.id}`, 
                              removeField: !!event.target.value
                            })
                          }}
                        />
                        {isEmptyField(`conditional.helper_text.${conditional.id}`) && 
                          <Form.Control.Feedback type="invalid">
                            Campo obrigatório
                          </Form.Control.Feedback>
                        }
                    </Form.Group> */}

              {formData.condicional_campos.length >= 2 && (
                <div className="mt-4 pt-2 col-md-1 col-sm-12 text-center">
                  <Button
                    variant="text"
                    className="border border"
                    title="Remover está condicional"
                    onClick={() => {
                      handleRemoveConditional(conditional.id)
                    }}
                  >
                    <FaTrash />
                  </Button>
                </div>
              )}
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
              <h2 className="fw-bold fs-5"> Lista de opções:</h2>
            </div>
            {(conditional.opcoes && conditional.opcoes.length > 0) &&
              conditional.opcoes.map((conditionalOption, conditionalOptionIndex) => (
                <div key={conditionalOption.id} className='row p-3 col-md-12'>
                  <Accordion
                    key={conditionalOption.id}
                    expanded={Boolean(expanded === conditionalOption.id)}
                    onChange={handleChangeAccordion(conditionalOption.id)}
                    className="flex gap-2 border"
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Form.Group style={{ maxWidth: 80 }} className="pe-2">
                        <FormLabelCustom>Opção</FormLabelCustom>
                        <Form.Control
                          placeholder="Opção"
                          readOnly
                          style={{ maxWidth: 38, aspectRatio: '2' }}
                          value={conditionalOptionIndex + 1}
                        />
                      </Form.Group>
                      <Form.Group className="ps-3 mb-3 col-md-5">
                        <FormLabelCustom required >Valor</FormLabelCustom>
                        <Form.Control
                          placeholder="Digite o valor da opção"
                          value={conditionalOption.resposta}
                          isInvalid={isEmptyField(`conditionalOption.${conditionalOption.id}`)}
                          required
                          onClick={(e) => e.stopPropagation()}
                          onChange={(event) => {
                            handleUpdateOptionInConditional({
                              conditionalIndex,
                              conditionalOptionIndex,
                              value: event.target.value,
                              fieldName: 'resposta'
                            });
                            removesFieldFromTheEmptyFields({
                              fieldName: `conditionalOption.${conditionalOption.id}`,
                              removeField: !!event.target.value
                            })
                          }}
                        />
                        {isEmptyField(`conditionalOption.${conditionalOption.id}`) &&
                          <Form.Control.Feedback type="invalid">
                            Campo obrigatório
                          </Form.Control.Feedback>
                        }
                      </Form.Group>
                      {conditionalOption.lista_campos.length > 0 && (
                        <Form.Group className="ps-3 mb-3 col-md-5">
                          <FormLabelCustom required>Titulo do formulário</FormLabelCustom>
                          <Form.Control
                            placeholder="Digite o titulo do formulário para o formulário"
                            value={conditionalOption.texto_ajuda}
                            isInvalid={isEmptyField(`conditionalOption.helper_text.${conditionalOption.id}`)}
                            required={conditionalOption.lista_campos.length > 0}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(event) => {
                              handleUpdateOptionInConditional({
                                conditionalIndex,
                                conditionalOptionIndex,
                                value: event.target.value,
                                fieldName: 'texto_ajuda'
                              });
                              removesFieldFromTheEmptyFields({
                                fieldName: `conditionalOption.helper_text.${conditionalOption.id}`,
                                removeField: !!event.target.value
                              })
                            }}
                          />
                          {isEmptyField(`conditionalOption.helper_text.${conditionalOption.id}`) &&
                            <Form.Control.Feedback type="invalid">
                              Campo obrigatório
                            </Form.Control.Feedback>
                          }
                        </Form.Group>
                      )}
                      {conditional.opcoes.length >= 2 && (
                        <div className="mt-4 ps-2 pt-2 col-md-12">
                          <Button
                            variant="text"
                            className="border"
                            title="Remover está opção da lista"
                            onClick={() => {
                              handleRemoveOptionInConditional({
                                conditionalIndex,
                                conditionalOptionIndex,
                              })
                            }}
                          >
                            <FaTrash />
                          </Button>
                        </div>
                      )}
                    </AccordionSummary>
                    <AccordionDetails>
                      <FormConditional
                        formData={formData}
                        setFormData={setFormData}
                        conditional={conditional}
                        conditionalIndex={conditionalIndex}
                        conditionalOption={conditionalOption}
                        conditionalOptionIndex={conditionalOptionIndex}
                        isEmptyField={isEmptyField}
                        removesFieldFromTheEmptyFields={removesFieldFromTheEmptyFields}
                      />
                    </AccordionDetails>
                  </Accordion>
                  {(conditional.opcoes && conditional.opcoes.length - 1 === conditionalOptionIndex) && (
                    <div className='col-md-12 pb-4 pt-4'>
                      <Button
                        onClick={() => {
                          handleAddNewOptionInConditional({
                            conditionalIndex,
                          })
                        }}
                      >
                        Adicionar uma nova opção
                      </Button>
                    </div>
                  )}

                </div>
              ))}


          </div>
        </div>
      ))}
      {formData.condicional_campos.length <= 0 && (
        <div className='col-md-12 my-4'>
          <Button
            onClick={handleAddConditional}
          >
            Adicionar uma nova condicional
          </Button>
        </div>
      )}
    </div>
  )
}